import { TESTIMONIALS } from "../../data";
import { Reveal } from "./Reveal";
import { Star, Quote } from "lucide-react";

export const Testimonials = () => (
  <section id="testimoni" className="relative py-24 sm:py-32 bg-[#faf7f2]">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="uppercase text-xs tracking-[0.28em] text-[#8b5a2b] mb-4">
          Ulasan Tamu
        </p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#2c1e16] max-w-3xl leading-tight">
          Dipercaya tamu di seluruh Yogyakarta.
        </h2>
        <p className="mt-5 max-w-xl text-[#5c4033] leading-relaxed">
          Cerita nyata dari mereka yang sudah merasakan sentuhan Massage kami.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-2">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08}>
            <figure
              data-testid={`testimonial-${i}`}
              className="h-full rounded-3xl border border-[#e5d9c5] bg-white/70 p-8 flex flex-col"
            >
              <Quote className="h-8 w-8 text-[#b8862f]" strokeWidth={1.25} />
              <div className="mt-4 flex gap-1">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star
                    key={s}
                    className="h-4 w-4 fill-[#b8862f] text-[#b8862f]"
                  />
                ))}
              </div>
              <blockquote className="mt-5 text-[#2c1e16] leading-relaxed flex-1 font-display text-xl sm:text-2xl">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-[#e5d9c5]">
                <span className="block text-[#2c1e16] font-medium">
                  {t.name}
                </span>
                <span className="block text-sm text-[#8b5a2b]">{t.area}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
